import useSWR from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import {
    badRequestError,
    invalidApiDataError,
} from "../../../../errors/recognisedErrors"
import { getClientProtected } from "../../clients/clients"
import { dnoHomepageMapper } from "../../mappers/dnoInterface/dnoHomepageMapper"
import { IDnoData } from "../../types/dnoInterface/dnoHomepageTypes"
import { DNO_REPORTING } from "../../urls/private"

interface IDnoHomepageData {
    data: IDnoData | undefined
    error: AppError | null
    isLoading: boolean
}

/**
 * Hook for getting the KPIs for the dashboard.
 * @returns {IDnoHomepageData} - SWR data, loading and error states.
 */
const useGetDnoHomepageData = (): IDnoHomepageData => {
    const { data, error, isLoading } = useSWR(
        DNO_REPORTING,
        async (url: string): Promise<IDnoData> => {
            try {
                const res = await getClientProtected(url)
                return dnoHomepageMapper.mapDnoData(res)
            } catch (err) {
                badRequestError("Failed to load KPI's")
                const appError = parseAndThrowAppError(err)
                throw invalidApiDataError(appError.message)
            }
        }
    )
    return {
        data,
        error,
        isLoading,
    }
}

export default useGetDnoHomepageData
